import React from "react";
import Chip from "material-ui/Chip";
import FilterChip from "@techsoftware/happay-widgets/FilterChip";

import { chipLableStyle, indvChip } from "../constants/style";

export default class CustomChip extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { label, onDelete, onRequestDelete, style, actionBorder, iconStyle } = this.props;
        let deleteIconStyle = {
            ...iconStyle,
            ...{ height: 17, width: 17, fill: "rgba(84, 105, 141, 0.3)" }
        };
        if (this.props.isWidgetComp) {
            return (
                <FilterChip
                    text={label}
                    onIconClick={!onRequestDelete && onDelete}
                    iconType={this.props.noIcon ? "" : this.props.iconType || "cross"}
                    iconSize={"micro"}
                    type={"primary"}
                    containerStyle={Object.assign(
                        {},
                        { padding: "3px 8px", margin: "0px 8px 12px 0px" },
                        this.props.containerStyle
                    )}
                    {...this.props}
                />
            );
        }
        return (
            <Chip
                {...this.props}
                labelStyle={chipLableStyle}
                style={Object.assign(indvChip, style || {})}
                deleteIconStyle={deleteIconStyle}
                className={actionBorder ? "chipActionBorder" : ""}
            >
                <div className="chipClass">{label}</div>
                {onDelete && !onRequestDelete ? (
                    <div onClick={onDelete} style={{ marginLeft: "8px" }}>
                        <img src="/assets/images/cross.svg" width="13px" />
                    </div>
                ) : null}
                {this.props.children}
            </Chip>
        );
    }
}
